import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageRedirect = () => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    // Redirect to the default language home page
    navigate(`/${currentLanguage}`, { replace: true });
  }, [navigate, currentLanguage]);

  return null; // This component doesn't render anything
};

export default LanguageRedirect;

